import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: '#47bd6c',
        fontFamily: 'YekanBakh-Bold'
    },
}));

export default function SearchBtn(props: any) {
    const classes = useStyles();
    return (
        <Button
            size="medium"
            onClick={(e) => props.onClickCallback()}
            variant="contained"
            color="secondary"
            className={classes.button}
            startIcon={props.icon ? <SearchIcon /> : null}
        >
            {props.label}
        </Button>
    )
}